<template>
  <div>
    <div style="background-color: #b3a258; color: #fff; padding: 10px 0;">
      <span :style="fontSize">{{topic}} </span>
      <v-btn  class="default" icon @click="isShow = !isShow">
        <v-icon>{{ isShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <v-simple-table v-show="isShow" style="margin: 10px;">
        <template v-slot:default>
          <thead>
            <tr>
              <th
              v-for="(data, index) in datas.header"
              :key="index"
              v-html="data.name"
              :class="data.class"
              :style="fontSize"
            ></th>
            </tr>
          </thead>
          <tbody >
            <tr v-for="(data, index) in datas.data.year" :key="index">
              <td v-for="(item, i) in data.seasonality" :key="i" v-html="item.name" :class="item.class" :style="fontSize"></td>
            </tr>
          </tbody>
          <tr><td v-bind:colspan="Object.keys(datas.header).length"  v-html="datas.remark" class="remark" :style="fontSize">  </td></tr>
        </template>
       
      </v-simple-table>
      
    </v-expand-transition>
    
  </div>
</template>

<script>
export default {
  name: "Seasonality",
  props: {
    datas: {}
  },
  data() {
    return {
      lang: this.$route.params.lang,
      isShow: false,
      fontSize: {},
      topic: ""
    };
  },
  methods: {
    loadStyle() {
      if (this.lang == 'en') {
        this.topic = "SEASONALITY";
      }
      else if (this.lang == 'th') { 
        this.topic = "ฤดูกาลท่องเที่ยว";
        this.fontSize = {
          "fontSize": "20px",
          "font-family": "Browallia New"
        };
      } else if(this.lang == 'cn') { this.topic = "季节"; }
    }
  },
  mounted() {
    this.loadStyle();
  }
};
</script>

<style scoped>

* {
  --avc-color: #b3a258;
  --text-color: #585859;
  --special-price-bg: #696a6d;
  --color-not-use: #efefef;
}
.resort-name {
  color: var(--text-color);
  background-color: white;
}
.guest {
  color: var(--text-color);
  background-color: white;
}
.normal-price {
  color: var(--text-color);
  background-color: white;
  width: 100px;
}
.special-price {
  color: var(--special-price-bg);
  background-color: var(--special-price-bg);
  width: 100px;
}
.low {
  background-color: #e6dfca;
  text-align: center;
}
.mid {
  background-color: #d4c9a0;
  text-align: center;
}
.high {
  background-color: #c3b57b;
  text-align: center;
}
table,
tr {
  border-spacing: 0px;
  border-collapse: collapse;
  border: 1px solid var(--avc-color);
}
th.low, th.mid, th.high, th.peak {
  text-align: center;
}
tbody,
td {
  border-bottom: 1px solid #eee;
  padding: 10px 5px;
}

.peak {
  color: var(--text-color);
  background-color: var(--avc-color);
}
.not-available {
  background-color: var(--color-not-use);
}
.remark {
  font-size: 0.9em;
}

.separate-line {
  border: 1px solid #efefef;
}
td {
  border: 1px solid #efefef;
}
@media (max-width: 575.98px) { 
  td {
    text-align: left;
    border: 1px solid #efefef;
  }
}

</style>